import {
  InvoiceNumberAPIResponse,
  BaseReducerState,
  InvoiceDetail,
} from '../../../services'
import { ActionTypes } from '../actions'

export type FetchInvoiceState = BaseReducerState & {
  data: InvoiceDetail
}

const initialFetchInvoiceState: FetchInvoiceState = {
  loading: false,
  success: false,
  message: '',
  data: null,
  error: null,
}

export const getInvoice = (
  state: FetchInvoiceState = initialFetchInvoiceState,
  action: { type: string; res: any }
): FetchInvoiceState => {
  switch (action.type) {
    case `${ActionTypes.FETCH_INVOICE}_REQUEST`:
      return {
        ...state,
        loading: true,
        success: false,
        message: null,
        data: null,
        error: null,
      }

    case `${ActionTypes.FETCH_INVOICE}_SUCCESS`: {
      const { success, data, message } = <InvoiceNumberAPIResponse>action.res
      return {
        ...state,
        loading: false,
        success,
        message,
        ...(success && data && { data }),
      }
    }
    case `${ActionTypes.FETCH_INVOICE}_FAILURE`: {
      const res = <InvoiceNumberAPIResponse>action.res
      const { message } = res || {}
      res.error ??= message
      const { error } = res
      return {
        ...state,
        loading: false,
        success: false,
        message,
        error,
      }
    }
  }
  return state
}
